// export const API_URL = "http://ec2-65-1-2-233.ap-south-1.compute.amazonaws.com:8081/api";
// export const API_URL = "http://localhost:8081/api";

export const API_URL = "https://smartsentech.com/api";
